<style lang="scss">




@media screen and (min-width: 55rem) {
  .schoolrecruitment {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    margin-top: 5rem;

    .schoolrecruitment-top {
      width: 80%;
      max-width: 1080px;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .schoolrecruitment-top-subtitle {
        font-size: 0.8rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #e5004f;
        line-height: 3.25rem;
        text-transform: uppercase;
      }
      .schoolrecruitment-top-title {
        font-size: 1.6rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: bold;
        color: #4b4b4b;
      }
      .schoolrecruitment-top-line {
        width: 2rem;
        height: 0.25rem;
        background-color: #e5004f;
        margin-top: 1rem;
      }
    }
    .schoolrecruitment-table {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      margin-top: 5rem;
      .schoolrecruitment-table-header {
        height: 3.8rem;
        width: 100%;
        background-color: rgba(150, 142, 142, 0.587);
        display: flex;
        flex-direction: row;
        align-items: center;

        .schoolrecruitment-table-header-type {
          width: 10%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .schoolrecruitment-table-header-position {
          width: 15%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .schoolrecruitment-table-header-duty {
          width: 60%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .schoolrecruitment-table-header-city {
          width: 15%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
      }
      .schoolrecruitment-table-product {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        height: 20rem;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 10%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 50%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 50%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          height: 100%;
          width: 15%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
      }
      .schoolrecruitment-table-business {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        height: 28rem;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 10%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 33.33%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 33.33%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-city-item {
              height: 33.33%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-city-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 400;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
      }
      .schoolrecruitment-table-project {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        height: 20rem;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 10%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 33.33%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-city-item {
              height: 33.33%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-city-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 400;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
      }
      .schoolrecruitment-table-buy {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        height: 8rem;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 10%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 100%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          height: 100%;
          width: 15%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
      }
      .schoolrecruitment-table-type {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        height: 20rem;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 10%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 20%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-city-item {
              height: 100%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-city-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 400;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
    .schoolrecruitment-bottom {
      width: 80%;
      max-width: 1080px;

      margin-top: 1rem;
      .schoolrecruitment-bottom-item {
        font-family:  'PingFang SC','Microsoft YaHei';
        color: #7f7f7f;
        font-size: 1.3125rem;
        font-weight: 400;
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .schoolrecruitment {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    margin-top: 5rem;
    .schoolrecruitment-top {
      width: 80%;
      max-width: 1080px;
      // height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .schoolrecruitment-top-subtitle {
        font-size: 0.8rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #e5004f;
        line-height: 3.25rem;
        text-transform: uppercase;
      }
      .schoolrecruitment-top-title {
        font-size: 1.6rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: bold;
        color: #4b4b4b;
      }
      .schoolrecruitment-top-line {
        width: 2rem;
        height: 0.25rem;
        background-color: #e5004f;
        margin-top: 1rem;
      }
    }
    .schoolrecruitment-table {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      margin-top: 5rem;
      .schoolrecruitment-table-header {
        height: 3.8rem;
        width: 100%;
        background-color: rgba(150, 142, 142, 0.587);
        display: flex;
        flex-direction: row;
        align-items: center;

        .schoolrecruitment-table-header-type {
          width: 10%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .schoolrecruitment-table-header-position {
          width: 15%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .schoolrecruitment-table-header-duty {
          width: 60%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .schoolrecruitment-table-header-city {
          width: 15%;
          text-align: center;
          font-size: 12px;
          font-family: 'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
      }
      .schoolrecruitment-table-product {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        height: auto;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 5%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          margin-left: 5%;
          width: 15%;
          height: 100%;
          min-height: 25rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 50%;
              width: 100%;
              min-height: 25rem;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 50%;
            width: 100%;
            min-height: 28rem;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          height: 100%;
          width: 15%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
      }
      .schoolrecruitment-table-business {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 5%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          margin-left: 5%;
          width: 15%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              min-height: 22rem;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            min-height: 22rem;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-item-list {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-city-item {
              height: 33.33%;
              width: 100%;
              display: flex;
              min-height: 22rem;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-city-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 400;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
      }
      .schoolrecruitment-table-project {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        height: 45rem;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 5%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          margin-left: 5;
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 33.33%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-city-item {
              height: 33.33%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-city-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 400;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
      }
      .schoolrecruitment-table-buy {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 5%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          width: 15%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 100%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          height: 100%;
          width: 15%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
      }
      .schoolrecruitment-table-type {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        border-bottom: 0.2rem #000000 solid;
        .schoolrecruitment-table-product-type {
          height: 100%;
          width: 10%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-type-title {
            font-size: 10px;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
        .schoolrecruitment-table-product-position {
          width: 15%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-position-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-position-item {
              height: 20%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-position-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 300;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
        .schoolrecruitment-table-product-duty {
          width: 60%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-duty-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            &:not(:first-of-type) {
              border-top: 0.1rem #000000 solid;
            }
            .schoolrecruitment-table-product-duty-item {
              text-align: start;
            }
          }
        }
        .schoolrecruitment-table-product-city {
          width: 15%;
          height: 100%;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .schoolrecruitment-table-product-city-item-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            .schoolrecruitment-table-product-city-item {
              height: 100%;
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              &:not(:first-of-type) {
                border-top: 0.1rem #000000 solid;
              }
              .schoolrecruitment-table-product-city-item-title {
                font-size: 10px;
                font-family: 'PingFang SC','Microsoft YaHei';
                font-weight: 400;
                color: #000000;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
    .schoolrecruitment-bottom {
      width: 80%;
      max-width: 1080px;

      margin-top: 1rem;
      .schoolrecruitment-bottom-item {
        font-family:  'PingFang SC','Microsoft YaHei';
        color: #7f7f7f;
        font-size: 1.3125rem;
        font-weight: 400;
      }
    }
  }
}
</style>

<script>
export default {
  name: "schoolrecruitment",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
